import { FC } from 'react';
import { Box, BoxProps } from '@qga/roo-ui/components';

type Props = BoxProps;

const Column: FC<Props> = (props) => <Box width={[1, 1 / 3]} my={2} {...props} />;

export default Column;
